/**
 * @generated SignedSource<<314b4555799c4cd330499e269514275c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleStatusRow_teamScheduleEventOccasion$data = ReadonlyArray<{
  readonly taskExecution?: {
    readonly routineOccasion: {
      readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleSectionHeaderStatusDot_routineOccasion">;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleSectionHeaderStatusDot_routineOccasion">;
  readonly " $fragmentType": "TeamScheduleStatusRow_teamScheduleEventOccasion";
}>;
export type TeamScheduleStatusRow_teamScheduleEventOccasion$key = ReadonlyArray<{
  readonly " $data"?: TeamScheduleStatusRow_teamScheduleEventOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleStatusRow_teamScheduleEventOccasion">;
}>;

const node: ReaderFragment = (function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "TeamScheduleSectionHeaderStatusDot_routineOccasion"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TeamScheduleStatusRow_teamScheduleEventOccasion",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "RoutineOccasion",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TaskExecutionCheck",
          "kind": "LinkedField",
          "name": "taskExecution",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoutineOccasion",
              "kind": "LinkedField",
              "name": "routineOccasion",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "TeamScheduleInlineRoutineOccasion",
      "abstractKey": null
    }
  ],
  "type": "TeamScheduleEventOccasion",
  "abstractKey": "__isTeamScheduleEventOccasion"
};
})();

(node as any).hash = "9e33ec875df815f7cf7c66ff2c1f9d64";

export default node;
